/* eslint-disable no-unused-vars */
import throttle from '../../js-plugins/throttle';
import slick from 'slick-carousel';

export default () => {

  const $imageSlider = $('.image-slider-slides');

  if ($imageSlider.length) {

    $imageSlider.slick({
      dots: true,
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      fade: true
    });

  }

};
